/* VoIPandSims cart sync shim — V17
   Purpose: prevent overlapping cart reconcilers.
   If V17 main cart sync (in cart.js) is active, this file stays idle.
*/
(() => {
  'use strict';

  if (window.__vnsCartSyncShimInstalledV17) return;
  window.__vnsCartSyncShimInstalledV17 = true;

  if (window.__vnsMainCartSyncInstalledV17 || window.__omniCartUIBridgeInstalledV2) {
    // Main cart bridge/sync is already responsible for cart events.
    return;
  }

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  const isCartMutation = (url, method) => {
    const u = String(url || '');
    const m = String(method || 'GET').toUpperCase();
    return m !== 'GET' && /\/cart\/(add|change|update|clear)\.js(?:\?|$)/.test(u);
  };

  const dispatchUpdated = (source = 'vns-shim') => {
    window.dispatchEvent(new CustomEvent('cart:updated', { detail: { source } }));
  };

  const origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (!origFetch) return;

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const method = (init && init.method) || (input && input.method) || 'GET';

    const res = await origFetch(input, init);
    if (isCartMutation(url, method) && res && res.ok) {
      setTimeout(() => dispatchUpdated('vns-shim'), 0);
    }
    return res;
  };

  // Fire once on load so consumers can sync initial state.
  document.addEventListener('DOMContentLoaded', () => dispatchUpdated('vns-shim-init'));
})();
